import { useEffect, useState } from 'react';

const useCountdown = (seconds) => {

    const [countDown, setCountDown] = useState(seconds);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountDown( (preVal) => preVal - 1);
        }, 1000);

        // console.log("countDown",getReturnValues(countDown));

        if(countDown <= 0) clearInterval(interval);

        return () => clearInterval(interval);
    }, [countDown]);

    return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
    // calculate time left
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
        (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

    return [days, hours, minutes, seconds];
};

export { useCountdown };
